module.exports = __webpack_public_path__ + "img/1745567642_knlZ.832f06a0.jpg";